import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import {
  ObjectKey,
  PersistMode,
  PersistObjectModel,
  PersistObjectsModel,
  TargetColumnValue,
  TargetObjectData,
} from '@barthauer/abc/core/data';

import { Measure, MeasureTask } from '@barthauer/custom/xmt-models';
import { ROLES } from '../../models/enumeration-list.model';
import { DataService, ObjectKeys } from '../../services/data.service';

export enum originOfCall {
  Gantt = 'Gantt',
  Measure = 'Measure',
}

@Injectable()
export class MilestoneTaskPopupService {
  constructor(private datePipe: DatePipe, private dataService: DataService) {}

  public preparePersistTask(
    currentMeasure: Measure,
    measureTask: MeasureTask,
    measureTaskId: string,
    mode: PersistMode
  ): PersistObjectModel {
    const measureTaskPersistQuery: TargetObjectData = new TargetObjectData();
    measureTaskPersistQuery.ObjectKey = new ObjectKey();
    measureTaskPersistQuery.ObjectKey.ObjectType = ObjectKeys.TASK;

    const measureTaskColumns: TargetColumnValue[] = [
      { Name: 'Type', Value: measureTask.Type },
      { Name: 'ParentId', Value: currentMeasure.Id },
      { Name: 'Subject', Value: measureTask.Label },
      { Name: 'IdRefResponsible', Value: measureTask.Responsible },
      { Name: 'TargetMaturityLevel', Value: measureTask.TargetMaturityLevel },
      { Name: 'StartDate', Value: this.datePipe.transform(measureTask.StartDate, 'yyyy-MM-dd') },
      { Name: 'EndDate', Value: this.datePipe.transform(measureTask.EndDate, 'yyyy-MM-dd') },
      { Name: 'DegreeOfImplementation', Value: measureTask.DegreeOfImplementation },
      { Name: 'Status', Value: measureTask.Status },
      { Name: 'ParentObjectType', Value: '330001131' },
      { Name: 'Comment', Value: measureTask.Comment },
    ];

    measureTaskPersistQuery.Mode = mode;
    if (mode == PersistMode.Update) measureTaskPersistQuery.ObjectKey.Id = measureTaskId;
    measureTaskPersistQuery.TargetColumns = measureTaskColumns;
    const persistObject: PersistObjectModel = new PersistObjectModel();
    persistObject.Object = measureTaskPersistQuery;

    return persistObject;
  }

  public prepareCollaborators(measureTask: MeasureTask, measureTaskId: string): PersistObjectsModel {
    const query: PersistObjectsModel = new PersistObjectsModel();
    const collaborattorPersistQuery: TargetObjectData[][] = [[]];
    measureTask.Collaborators.forEach((newCollaborator) => {
      const collaboratorsPersistObjectData: TargetObjectData = new TargetObjectData();
      collaboratorsPersistObjectData.Mode = PersistMode.Insert;
      collaboratorsPersistObjectData.ObjectKey = new ObjectKey();
      collaboratorsPersistObjectData.ObjectKey.ObjectType = ObjectKeys.COLLABORATOR;
      const collaboratorColumns: TargetColumnValue[] = [
        { Name: 'ParentId', Value: measureTaskId },
        { Name: 'IdRefMeasureResource', Value: newCollaborator['IdRefMember'] },
        { Name: 'TimeExecuted', Value: newCollaborator.TimeExecuted },
        { Name: 'TimePlanned', Value: newCollaborator.TimePlanned },
        { Name: 'Period', Value: new Date().toDateString() },
      ];
      collaboratorsPersistObjectData.TargetColumns = collaboratorColumns;
      collaborattorPersistQuery[0].push(collaboratorsPersistObjectData);
    });
    query.Objects = collaborattorPersistQuery;
    return query;
  }
  public IsRoleAuthorizedToUpdateDate(isUpdating: boolean): boolean {
    if (isUpdating) {
      return this.dataService.hasNonAuthrisedRole([ROLES.Admin]);
    } else return false;
  }
}
